export const PHONE_WIDTH = 480;
